<template>
    <div class="frame-wrap">
        <div class="frame-main" v-if="isShowMessage">
            <div class="el-icon-close" @click="closeBtn" style="cursor:pointer;"></div>
            <div class="frame-main-con" :style="{height:height}">
                <p class="frame-title">{{$t('business.demandDetails')}}</p>
                <div class="frame-top">
                    <img :src="$imgUrl + userInfo.avatar" alt="">
                    <div class="frame-infor">
                        <p class="frame-infor-title">{{userInfo.name}}
                            <span v-if="langSet == 'zh' || userInfo.en_dutiesName.length == 0">{{userInfo.dutiesName}}</span>
                            <span v-if="langSet == 'en' && userInfo.en_dutiesName.length > 0">{{userInfo.en_dutiesName}}</span>
                        </p>
                        <p>{{userInfo.company}}</p>
                        <p>{{userInfo.mobile}}</p>
                    </div>
                </div>
                <ul class="frame-list">
                    <li>
                        <p class="frame-list-title">{{$t('business.businessMode')}}<span>{{$t('business.multi')}}</span></p>
                        <div class="frame-label">
                            <p class="active" v-if="userInfo.type[0] > 0" >{{$t('business.trade')}}</p>
                            <p class="active" v-if="userInfo.type[1] > 0" >{{$t('business.internationalTrade')}}</p>
                        </div>
                    </li>
                    <li v-if="userInfo.label != null && userInfo.label.length > 0">
                        <p class="frame-list-title">{{$t('business.demandTag')}}</p>
                        <div class="label-list frame-label">
                            <p class="active" v-for="(item, index) in userInfo.label" :key="index">
                                <span v-if="langSet == 'zh' || item.en_name.length == 0">{{item.name}} </span>
                                <span v-if="langSet == 'en' && item.en_name.length > 0">{{item.en_name}} </span>
                            </p>
                        </div>
                    </li>
                    <li v-if="userInfo.imgs.length > 0">
                        <p class="frame-list-title">{{$t('business.demandPhoto')}}</p>
                        <div class="frame-upimg">
                            <div class="upimg" v-for="(item, index) in userInfo.imgs" :key="index">
                                <img :src="$imgUrl + item.url" alt="">
                            </div>
                        </div>
                    </li>
                    <li v-if="userInfo.description.length > 0 || userInfo.en_description.length > 0">
                        <p class="frame-list-title">{{$t('business.demandMessage')}}</p>
                        <div v-if="langSet == 'zh' || userInfo.en_description.length == 0" class="label-list frame-label">{{userInfo.description}}</div>
                        <div v-if="langSet == 'en' && userInfo.en_description.length > 0" class="label-list frame-label">{{userInfo.en_description}}</div>
                    </li>
                </ul>
                <div class="pop">
                    <el-popover
                    placement="top"
                    width="160"
                    v-model="visible">
                        <p>{{userInfo.mobile}}请电话联系</p>
                        <div style="text-align: right; margin: 0">
                            <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
                        </div>
                    <el-button class="frame-publish btn" slot="reference">{{$t('business.call')}}</el-button>
                 </el-popover>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { getNeedDetail, getNeedLabel,needReply } from "@/api/api";
export default {
    props: [ 'detailsId' ],
    data() {
        return {
            tradeChoose:[
                {
                    title: '中国国内贸易',
                    state: true
                },
                {
                    title: '国际贸易',
                    state: false
                }
            ],
            demandCurrent: 0,
            labelList:[],
            height: '',
            chinese: '',
            en: '',
            userInfo:{
                type:[],
                label: [],
                imgs: [],
                description: '',
                en_dutiesName: [],
                en_description: '',
            },
            memberid: '',
            langSet: '',
            isShowMessage: true,
            messageContent: '',
            placeholder: '',
            visible: false,
        }
    },
    created() {
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.memberid = localStorage.getItem('memberid');
        this.placeholder = this.$t('bussindess.inputContents');
        this.getLabel();
        this.setHeight();
        this.getData(this.detailsId);
    },
    computed:{

    },
    methods: {
        closeBtn(){
            this.$emit('close-details', false)
        },
        setHeight(){
            this.height = window.innerHeight  - 250 + 'px';
        },
        getData(id){
            let data = this.$qs.stringify({
                memberid: this.memberid,
                id
            })
            getNeedDetail(data).then(res=>{
                //console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.userInfo = res.data.rst;
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        changeTrade(index){
           let item = this.tradeChoose[index];
           item.state = ! item.state;
        },
        demandTrade(index){
            this.demandCurrent = index;
        },
        demandLabel(index){
            let item = this.labelList[index];
            item.state = ! item.state;
        },
        getLabel(){
            let data = this.$qs.stringify({
                memberid: this.memberid,
            })
            getNeedLabel(data).then(res=>{
                //console.log(res.data)
                if(res.data.errno == 0){
                    res.data.rst.forEach(item => {
                        item.state = false;
                    })
                    this.labelList = res.data.rst;
                }   
            }).catch(err=>{
                console.log(err)
            })
        },
        answerBtn(){
            //console.log(222)
            //this.isShowMessage = false;
        },
        closeMessageBtn(){
            this.isShowMessage = true;
        },
        submit(){
            if(this.messageContent.length == 0){
                if(this.langSet == 'zh'){
                    this.$message('内容不能为空！');
                }else{
                    this.$message('The content cannot be empty!');
                }
            }else{
                //console.log(this.detailsId)
                let data = this.$qs.stringify({
                    memberid: this.memberid, 
                    needid: this.detailsId, 
                    reply: this.messageContent
                })
                needReply(data).then(res=>{
                    console.log(res)
                }).catch(err=>{
                    console.log(err)
                })
            }
        }
    },
    watch: {
        $route (to, from) {
            this.$router.go(0)
        }
    }
}
</script>

<style lang="scss">
.pop .frame-publish.btn{padding: 0;outline: 0 none;color: #fff !important;display: block;}
.frame-answer{border-top:1px solid #E0E0E0;}
.frame-answer .frame-answer-title{font-size:20px;color: #000;line-height:28px;padding:19px 0 15px;}
.frame-answer-list{display: flex;justify-content: space-between;flex-wrap: wrap;}
.frame-answer-list li{width: 49%;height: 146px;background: #ECE9EA;border-radius: 5px;margin-bottom: 20px;}
.frame-answer-btn{display: flex;justify-content: center;}
.frame-answer-btn p{width:140px;height:32px;background:rgba(222,110,98,1);border-radius:5px;color: #fff;text-align: center;line-height: 34px;font-size:15px;border:1px solid rgba(222,110,98,1);cursor: pointer;}
.frame-answer-btn .frame-del-btn{color: #E06D5F;background: #fff;margin-right: 20px;}
.frame-wait p{font-size:18px;color:rgba(214,114,108,1);line-height:25px;text-align: center;}
.frame-wait div{width:375px;height:62px;background:rgba(214,114,108,1);text-align: center;font-size:16px;color:rgba(255,255,255,1);line-height:20px;padding: 0 80px;box-sizing: border-box;display: flex;align-items: center;margin: 15px auto 0;}
.frame-wrap .frame-top .frame-infor .frame-infor-title span{font-size: 14px;color: #666;}
.frame-main{
    overflow-y: scroll;
    .message-top{
        display: flex;
        color: #666;
        font-size: 20px;
        line-height:28px;
        justify-content: space-between;
    }
    .message-top .el-icon-circle-close{
        font-size: 26px;
    }
    .message-info{
        padding: 25px;
        background:rgba(244,244,244,1);
        border-radius:16px;
        .frame-top{
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
            border-radius:10px;
        }
        .message-content{
            color: #666;
            padding: 18px 0;
            line-height:28px;
        }
        .message-img{
            display: flex;
            img{
                width:120px;
                height:120px;
                margin-right: 20px;
            }
        }
    }
    .reply-message{
        font-size: 20px;
        color: #666;
        line-height:28px;
        padding: 33px 0 4px;
        position: relative;
        .el-textarea__inner{
            height:178px;
            font-family: "PingFang SC","Helvetica Neue",Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        }
        .tips{
            position: absolute;
            bottom: 5px;
            right: 7px;
            font-size:16px;
            color: #878787;
            line-height:22px;
        }
    }
    .messagebtn{
        width:133px;
        height:40px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        margin: 20px auto 0;
        cursor: pointer;
        background:rgba(186,69,64,1);
    }
}
@media only screen and (max-width: 767px){
    .frame-wrap{
        .frame-main{
            width: 95%;
            padding: 0.2rem;
        }
        .frame-title{
            font-size: 20px;
        }
        .frame-top{
            width: 100%;
            padding: 0.2rem 0.5rem 0.2rem 0.2rem;
        }
    }
    .frame-main-con{
        padding: 0 0.2rem;
    }
    .frame-wrap .frame-top .frame-infor .frame-infor-title{font-size: 16px;}
    .frame-list li .frame-list-title{font-size: 18px;}
    .frame-label p{margin-bottom: 0.2rem;}
    .cell-item-wrap{column-count:1;column-gap: 0;}
    .cell-item{width: 100%;}
    .cell-list{width: 98%;}
}
</style>